export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-axis/src/identity.js
// module id = xxui
// module chunks = 0